import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../core/root-store';
import OnboardingStepPhoneNumberUi from '../ui/screens/onboarding-step-phone-number.ui';

const OnboardingStepPhoneNumberContainer = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const store = rootStore.onboardingStore;

  const stepErrors = store.shouldShowStepErrors;

  return (
    <OnboardingStepPhoneNumberUi
      phone={store.formData.phone}
      phoneNumberError={stepErrors.phone}
      onUpdatePhoneNumber={store.updatePhoneNumber}
      isSubmitting={store.isSavingStep}
    />
  );
});

export default OnboardingStepPhoneNumberContainer;
